<div class="modal-header">
  <h4 class="modal-title">Checkout Information</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <!-- Checkout Summary -->
  <div class="checkout-summary mb-4">
    <h5>Order Summary</h5>
    <div class="summary-item">
      <div class="d-flex mb-2">
        <span class="me-2">Items:</span>
        <span class="fw-bold">{{ itemCount }}</span>
      </div>
      <div class="d-flex">
        <span class="me-2">Total:</span>
        <span class="fw-bold">RM{{ totalPrice.toFixed(2) }}</span>
      </div>
    </div>
  </div>

  <!-- Customer Information Form -->
  <form [formGroup]="customerForm" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label for="name" class="form-label">Full Name *</label>
      <input
        type="text"
        id="name"
        class="form-control"
        formControlName="name"
        [class.is-invalid]="name?.invalid && name?.touched"
        placeholder="Enter your full name"
      />
      <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
        <div *ngIf="name?.errors?.['required']">Name is required</div>
        <div *ngIf="name?.errors?.['minlength']">Name must be at least 2 characters</div>
      </div>
    </div>

    <div class="mb-3">
      <label for="email" class="form-label">Email Address *</label>
      <input
        type="email"
        id="email"
        class="form-control"
        formControlName="email"
        [class.is-invalid]="email?.invalid && email?.touched"
        [placeholder]="isLoggedIn ? '' : 'Enter your email address'"
        [readonly]="isLoggedIn"
      />
      <div *ngIf="isLoggedIn" class="form-text text-muted">
        <small
          ><i class="fas fa-info-circle me-1"></i>Email is automatically filled from your
          account</small
        >
      </div>
      <div *ngIf="email?.invalid && email?.touched && !isLoggedIn" class="invalid-feedback">
        <div *ngIf="email?.errors?.['required']">Email is required</div>
        <div *ngIf="email?.errors?.['email']">Please enter a valid email address</div>
      </div>
    </div>

    <div class="mb-3">
      <label for="phone" class="form-label">Phone Number *</label>
      <ngx-intl-tel-input
        [cssClass]="'form-control'"
        [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="true"
        [enablePlaceholder]="true"
        [customPlaceholder]="'141234567'"
        [searchCountryFlag]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
        [selectFirstCountry]="false"
        [selectedCountryISO]="CountryISO.Malaysia"
        [maxLength]="15"
        [phoneValidation]="true"
        [separateDialCode]="separateDialCode"
        [inputId]="'phone'"
        name="phone"
        formControlName="phone"
        [class.is-invalid]="phone?.invalid && phone?.touched"
      ></ngx-intl-tel-input>
      <div class="form-text text-muted">
        <small
          ><i class="fab fa-whatsapp me-1"></i>Please use a number with WhatsApp for
          notifications</small
        >
      </div>
      <div *ngIf="phone?.invalid && phone?.touched" class="invalid-feedback">
        <div *ngIf="phone?.errors?.['required']">Phone number is required</div>
        <div *ngIf="phone?.errors?.['validatePhoneNumber']">Please enter a valid phone number</div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary"
    (click)="close()"
    [disabled]="isProcessingCheckout"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="onSubmit()"
    [disabled]="isProcessingCheckout || customerForm.invalid"
  >
    <span
      *ngIf="isProcessingCheckout"
      class="spinner-border spinner-border-sm me-2"
      role="status"
    ></span>
    {{ isProcessingCheckout ? 'Processing...' : 'Proceed to Payment' }}
  </button>
</div>
